<template>
  <div>
    <input
      type="file"
      :id="id"
      :multiple="multiple"
      @change="onFileSelected"
    />
    <label :for="id">
      <span>
        <slot name="label">
          <template v-if="count === 1">{{ first.name }}</template>
          <template v-else-if="count > 1">{{ count }} files selected.</template>
          <template v-else>Select files...</template>
        </slot>
      </span>
      <strong>
        <slot name="button">
          UPLOAD
        </slot>
      </strong>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: []
    }
  },
  computed: {
    count () {
      return this.files.length
    },
    first () {
      const [head] = this.files
      return head
    }
  },
  methods: {
    onFileSelected (e) {
      const selected = e.target.files || e.dataTransfer.files

      if (!selected.length) {
        return
      }

      const files = []
      Array.prototype.forEach.call(
        selected,
        file => files.push(file)
      )
      this.files = files

      this.multiple
        ? this.$emit('input', files)
        : this.$emit('input', this.first)
    }
  }
}
</script>

<style lang="scss" scoped>

$buttonColor: #c2063b;
$buttonFontColor: #fff;
$buttonHoverColor: #c2063b;
$buttonHoverFontColor: #fff;

$labelFontColor: #6c6e6e;
$labelBorderColor: #6c6e6e;

input[type="file"] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

  + label {
    display: inline-block;
    cursor: pointer;
  }

  &:focus {
    outline: none;

    + label {
      outline: 1px dotted black;
    }
  }
}

/* style  */
input[type='file'] {
  + label {
    padding: 0;

    strong {
      font-weight: 300;
      display: inline-block;
      font-size: 14px;
      color: $buttonFontColor;
      letter-spacing: 0.05px;
      text-align: left;
      background-color: $buttonColor;
      padding: 5px 20px;
      border: none;
      text-transform: uppercase;
      transition: 0.2s linear;
      cursor: pointer;
      margin-left: 20px;

      @media screen and (max-width: 576px) {
        display: block;
      }
    }

    span {
      padding: 6px 15px;
      font-weight: 300;
      min-width: 200px;
      max-width: 250px;
      min-height: 31px;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      vertical-align: top;
      border: 1px solid $labelBorderColor;
      color: $labelFontColor;
      font-size: 14px;
      line-height: 1;
    }

    &:hover {

      strong {
        color: $buttonHoverFontColor;
        background-color: $buttonHoverColor;
      }
    }

    &:focus {
      outline: 0;
    }
  }
}
</style>
